<style lang="scss" scoped>
.subcategory {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;

  background: rgba(246, 246, 246, 0.7);

  flex: none;

  @include opacity-show;
  .subcategory-item {
    display: flex;

    position: relative;

    width: 1.44rem;
    padding: 0.32rem 0.24rem 0.32rem 0.24rem;

    align-items: center;

    color: #666;

    flex-flow: row nowrap;
    & > span {
      display: block;

      font-size: 0.24rem;

      word-wrap: break-word;
      word-break: break-all;
    }
    &.active {
      background-color: #fff;
      background-size: 3px 0.32rem;

      font-weight: 700;
      color: #333;

      &:after {
        display: none;
      }
    }

    .promote-tag {
      width: 0.24rem;
      height: 0.24rem;
      margin-right: 0.08rem;
    }
  }
}
</style>

<template>
  <ul class="subcategory">
    <li
      v-for="(item_sub, index) in subList"
      :key="item_sub.id"
      class="subcategory-item"
      :class="{
        active: index == activeIndex,
        promote:
          item_sub.id == 0 || item_sub.id == '1_0' || item_sub.id == '0_6'
      }"
      @click="handleNavClick(item_sub, index, $event)"
    >
      <img
        v-if="item_sub.id == 0"
        class="promote-tag"
        src="@/images/pop/goods_promote.png"
      />
      <img
        v-if="item_sub.id == '0_6'"
        class="promote-tag"
        src="@/images/pop/goods_ combo.png"
      />
      <span>
        {{ item_sub.name }}
      </span>
    </li>
  </ul>
</template>

<script>
import { ScrollAnimate } from '@/utils/utils'
const scrollAni = new ScrollAnimate()

export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['subList', 'activeIndex'],
  watch: {
    activeIndex(n) {
      const target = document.getElementsByClassName('subcategory-item')[n]
      if (target) {
        scrollAni.scrollTo({
          el: this.$el,
          start: this.$el.scrollTop,
          end: target.offsetTop - 50
        })
      }
    }
  },

  activated() {
    const target = document.getElementsByClassName('subcategory-item active')[0]
    if (target) {
      scrollAni.scrollTo({
        el: this.$el,
        start: this.$el.scrollTop,
        end: target.offsetTop - 50
      })
    }
  },
  methods: {
    handleNavClick: function (obj, index, event) {
      this.$emit('operating', {
        item: obj,
        index
      })
    },
    calcClassName(item) {
      return item.id === 0 ? 'promote' : ''
    }
  }
}
</script>
